import React, { useEffect } from "react";
import OurJourney from "./HomeComponents/OurJourney";
import OurExpertise from "./HomeComponents/OurExpertise";
import WhyChooseUs from "./HomeComponents/WhyChooseUs";
import WhoWeAre from "./HomeComponents/WhoWeAre";
import WhatWeDo from "./HomeComponents/WhatWeDo";
import WhatWeLike from "./HomeComponents/WhatWeLike";
import TrainingModule from "./HomeComponents/TrainingModule";
import FooterCTA from "./HomeComponents/FooterCTA";

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className="banner aboutus section" id="home">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>About Fidus</h1>
        </div>
      </div>
      <OurJourney />
      <OurExpertise hideOnMobile={false} />
      <WhyChooseUs hideOnMobile={false} />
      <WhoWeAre hideOnMobile={false} />
      <WhatWeDo hideOnMobile={false} />
      <WhatWeLike hideOnMobile={false} />
      <TrainingModule hideOnMobile={false} />
      <FooterCTA />
    </>
  );
};

export default About;
